module.exports = __webpack_public_path__ + "img/4.a52ca7e8.png";